/* eslint-disable jsdoc/require-returns */
const waiNotify = require('../components/waiNotify');

const selectors = {
    cart: '.js-cart'
};

const $productContainer = $(selectors.cart);
const notifications = {
    attr:  $productContainer.data('action-message-attr'),
    registry: $productContainer.data('action-message-registry'),
    canceled: $productContainer.data('action-message-canceled')
};

function setColorName() {
    const colorName = $('.js-color-button.m-selected').data('attr-value');
    if (colorName) {
        $('.js-selected-color').text(colorName);
    }
}

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {object} response - response from Ajax call
 * @param {object} response.product - Product object
 * @param {string} response.uuidToBeDeleted - uuid of section to be deleted
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {JQuery<HTMLElement>} $productContainer - DOM element for a given product.
 * @param {JQuery<HTMLElement>} curretTarget - Current event
 */
function handleVariantResponse(response, $productContainer, curretTarget) {

    let containerAttr = curretTarget.closest('.js-product-attributes_container');

    if (response.product.variationAttributes) {
        updateAttrs(response.product.variationAttributesMarkup, containerAttr);
        const containerAttrParent = containerAttr.closest('.b-product_details-variation');

        const priceDiv = containerAttrParent.siblings('.b-product_cart-price');
        const $priceSelector = $('.js-price', priceDiv).length
            ? $('.js-price', priceDiv)
            : $('.js-price');
        $priceSelector.replaceWith(response.product.price.html);
    }
}

function verifyNotSelectedVariants() {
    var $productCards = $('.b-product_cart');
    if ($productCards.length > 0) {
        let disableCheckout = false;
        for (let i = 0; i < $productCards.length; i++) {
            let $variationOptions = $($productCards[i]).find('.b-product_variation');
            if ($variationOptions.length > 0) {
                for (let j = 0; j < $variationOptions.length; j++) {
                    let $colors = $($variationOptions[j]).find('.js-color-button');
                    let $selectedColors = $($variationOptions[j]).find('.js-color-button.m-selected');
                    if ($colors.length > 0 && $selectedColors.length === 0) {
                        disableCheckout = true;
                    }

                    let $selectedOption = $($variationOptions[j]).find('.js-attribute-select option:selected');
                    if ($selectedOption.length > 0 && $selectedOption.hasClass('js-reset_option')) {
                        disableCheckout = true;
                    }
                }
            }
        }
        if (disableCheckout) {
            $('.js-checkout-btn').addClass('m-disabled');
            $('.js-pay-pal-checkout-btn').addClass('m-disabled');
        } else {
            $('.js-checkout-btn').removeClass('m-disabled');
            $('.js-pay-pal-checkout-btn').removeClass('m-disabled');
        }
    }
}

/**
 * Routes the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {object} attributesMarkup - rendered markup with variation attributes
 * @param {JQuery<HTMLElement>} containerAttr - DOM element for a given product
 */
function updateAttrs(attributesMarkup, containerAttr) {
    containerAttr.html(attributesMarkup);
    setColorName();
}

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {JQuery<HTMLElement>} $productContainer - DOM element for current product
 * @param {JQuery<HTMLElement>} curretTarget - current target on variation
 * @param {string} message - notification about applied changes
 * @param {number} setIndex - set selected default index or not
 */
function attributeSelect(selectedValueUrl, $productContainer, message, setIndex, curretTarget) {
    if (!selectedValueUrl) {
        return;
    }

    const selectedValueUrlCart = selectedValueUrl.replace('product-variation', 'cart-updatelineitem');
    const sectionProduct = curretTarget.closest('.js-product-info');
    const sectionUuid = sectionProduct.attr('data-uuid');
    const url = selectedValueUrlCart + '&uuid=' + sectionUuid;

    $('body').trigger('product:beforeAttributeSelect',
        { url: selectedValueUrl, container: $productContainer });
    const $cart = $(selectors.cart);

    $cart.attr('aria-busy', true);
    $cart.spinner().start();
    $.ajax({
        url: url,
        method: 'GET',
        success(data) {
            // remove error/warning message content
            sectionProduct.find('.js-product_availability').empty();

            if (setIndex) {
                $(`.js-attribute-select option[value="${selectedValueUrl}"]`).prop('selected', true);
            }
            handleVariantResponse(data, $productContainer, curretTarget);

            $('body').trigger('product:afterAttributeSelect',
                { data, container: $productContainer });

            $cart.attr('aria-busy', false);
            $cart.spinner().stop();
            if (data.uuidToBeDeleted) {
                $(`.js-product-info[data-uuid=${data.uuidToBeDeleted}]`).remove();
            }

            verifyNotSelectedVariants();

            $('body')
                .trigger('basket:update:bonus:products', data.cartModel)
                .trigger('basket:update:totals', data.cartModel)
                .trigger('basket:update:discounts', {discounts: data.cartModel.approachingDiscounts})
                .trigger('basket:update:promos', data.cartModel.totals.discountsHtml)
                .trigger('basket:validate', data.cartModel)
                .trigger('basket:update:quantity', data)
                .trigger('minicart:update:content', data.cartModel)
                .trigger('basket:update:details', {data: data, uuid: sectionUuid})
                .trigger('basket:update:availability', {data: data, uuid: sectionUuid})
                .trigger('cart:update');
        },
        error(data) {
            $cart.attr('aria-busy', false);
            $cart.spinner().stop();
            if (data.responseJSON) {
                sectionProduct.find('.js-product_availability').empty().html(data.responseJSON.errorMessage);
            } else {
                waiNotify(notifications.canceled);
            }
        }
    });
}

module.exports = {
    attributeSelect,

    colorAttribute() {
        $(document).on('click', '.js-color-button', (e) => {
            e.preventDefault();
            const $button = $(e.currentTarget);

            if ($button.attr('disabled') || $button.hasClass('m-unselectable')) {
                return;
            }
            let $productContainer = $button.closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $button.closest(selectors.cart);
            }
            const notificationMessage = $button.data('attr-value') + ' ' + notifications.attr;
            attributeSelect($button.attr('data-url'), $productContainer, notificationMessage, 0, $button);
        });
    },

    selectAttribute() {
        $(document).on('change', '.js-attribute-select', (e) => {
            e.preventDefault();
            const $attr = $(e.currentTarget);

            let $productContainer = $attr.closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $attr.closest(selectors.cart);
            }

            const $selected = $attr.find('option:selected');
            const notificationMessage = $selected.text() + ' ' + notifications.attr;

            attributeSelect($selected.val(), $productContainer, notificationMessage, 0, $attr);
        });
    },
    setColorName
};
